import React from 'react';
import { Label, Tag, Text, Group} from 'react-konva';
import {INPUT, OUTPUT} from './constants.js';

const fill ='#4f4d54';
const modeToText = {
    INPUT: 'Input for node',
    OUTPUT: 'Output for node',
};

export default function Tooltip({x, y, mode, parameter}) {
    let direction = mode === INPUT ? "down"  : "up";
    let text = modeToText[mode];
    if (parameter && parameter.name) {
        text = parameter.name + ": " + parameter.get();
    }
    y = mode === INPUT ? y - 5 : y + 5;
    let width = text.length * 8;
    return (
        <g>
          <rect className="rack-tooltip" x={x} y={y-15} height={15} width={width}/>
          <text
            className="tooltip-text"
            fontSize={12}
            fill="white" x={x+5} y={y - 3}>
            {text}
          </text>
        </g>
    );
}
